"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Relevancy = exports.SortDirection = void 0;
var SortDirection;
(function (SortDirection) {
    SortDirection["NewToOld"] = "newToOld";
    SortDirection["OldToNew"] = "oldToNew";
})(SortDirection || (exports.SortDirection = SortDirection = {}));
var Relevancy;
(function (Relevancy) {
    Relevancy["High"] = "High";
    Relevancy["Medium"] = "Medium";
    Relevancy["All"] = "All";
})(Relevancy || (exports.Relevancy = Relevancy = {}));
